import { makeStyles } from '@mui/styles';
import { alpha } from '@mui/material/styles';

export const useStyles = makeStyles(theme => ({
	paper: {
		maxWidth: 420,
		padding: theme.spacing(2)
	},
	content: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		textAlign: 'center',
		gap: theme.spacing(2)
	},
	badge: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		width: 56,
		height: 56,
		borderRadius: '50%',
		backgroundColor: alpha(theme.palette.primary.main, 0.08),
		color: theme.palette.primary.main
	},
	button: {
		width: '100%'
	}
}));
